export default {"src":"/_next/static/media/ic-move.8b84e4db.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};